import get from 'lodash/get'
import { selectOptions } from '../../containers/App/selectors'
import { ANALYTICS_IDS, GTM_ID } from '../../constants/index'

// Used to retrieve options outside components directly from state (e.g. sagas)
export const getOptionFromState = state => {
  const options = selectOptions(state)
  return getOptionHelper(options)
}

// Used to retrieve options in components
export const getOptionFromArgs = options => (
  getOptionHelper(options)
)

// Helper to extract options, not to be used directly.
const getOptionHelper = options => (
  (path, defaultValue = null) => {
    // Try get value, fallback to defaultValue
    const value = get(options, path, defaultValue)

    // Lodash does not fall back to default for null values
    if (value === null) {
      return defaultValue
    }

    return value
  }
)

export const getAnalyticsIds = state => {
  const getOption = getOptionFromState(state)
  const analyticsIds = getOption('analyticsIds', [])

  // Merge customer provided analytics with our default
  return [...analyticsIds, ...ANALYTICS_IDS]
}
export const getGTMId = state => {
  const getOption = getOptionFromState(state)
  const gtmId = getOption('gtmId', '')

  return gtmId || GTM_ID
}


// WEBPACK FOOTER //
// ./src/hocs/OptionsHOC/helpers.js